import type { StatusType } from '@datadog/browser-logs'
import { datadogLogs } from '@datadog/browser-logs'

export type Level = StatusType

export type LogEvent = {
  message: string
  context?: object
  level?: Level
  error?: Error
}

export function log(event: LogEvent) {
  datadogLogs.logger.log(event.message, event.context, event.level, event.error)
}
